/** The data bank's sources by key, in Arabic. Products keep their brand, written in Arabic letters the way the Arabic press writes it. */
const SOURCES_AR: Record<string, string> = {
  "abudhabi-adra": "دائرة التنمية الاقتصادية في أبوظبي وهيئة تسجيل أبوظبي ومنصة تم – الرخص والتسجيلات",
  "abudhabi-opendata": "منصة أبوظبي للبيانات المفتوحة (سوق أبوظبي للأوراق المالية، المصرف المركزي، إحصاءات الرخص)",
  adx: "سوق أبوظبي للأوراق المالية – الشركات المدرجة وبياناتها",
  aecb: "شركة الاتحاد للمعلومات الائتمانية – تقارير الائتمان (بموافقة الشركة)",
  bayanat: "بيانات – البوابة الوطنية للبيانات المفتوحة",
  bbc: "بي بي سي نيوز",
  bloomberg: "بلومبرغ – رخصة البيانات",
  casefiling: "طلبات الحالات (نماذج إدارة المنافسة)",
  cbuae: "مصرف الإمارات العربية المتحدة المركزي – سجل المؤسسات المالية وشركات التأمين المرخصة",
  "cedar-rose": "سيدار روز – تقارير الائتمان والتحقق من الشركات في المنطقة",
  chambers: "أدلة أعضاء غرف دبي وغرفة أبوظبي",
  cma: "هيئة سوق رأس المال – الشركات المرخصة",
  "company-self-report": "بيانات المبيعات والسوق التي تقدمها الشركات (طلب البيانات)",
  crunchbase: "كرنش بيس",
  dfm: "سوق دبي المالي وناسداك دبي – الأسهم المدرجة وكبار المساهمين",
  dfsa: "سلطة دبي للخدمات المالية – السجل العام للشركات (مركز دبي المالي العالمي)",
  "dha-doh": "هيئة الصحة بدبي (شريان) ودائرة الصحة في أبوظبي – رخص المنشآت الصحية",
  "dld-adrec": "دائرة الأراضي والأملاك في دبي (ريرا) ومركز أبوظبي العقاري – المطورون والوسطاء",
  "dnb-crif": "دن آند برادستريت عبر كريف الخليج",
  "dubai-det": "دائرة الاقتصاد والسياحة في دبي – الرخص التجارية",
  "dubai-pulse": "نبض دبي – البيانات المفتوحة (الأسماء التجارية والأنشطة والرخص)",
  factset: "فاكت ست – البيانات المالية الأساسية",
  fca: "الهيئة الاتحادية للجمارك – الواردات والصادرات حسب رمز النظام المنسق والمستورد والإمارة",
  fcsc: "المركز الاتحادي للتنافسية والإحصاء",
  "forbes-me": "فوربس الشرق الأوسط – التصنيفات",
  freezones: "سجلات المناطق الحرة (مركز دبي المالي العالمي، سوق أبوظبي العالمي، مركز دبي للسلع المتعددة، جافزا، راكز وغيرها)",
  fsra: "سلطة تنظيم الخدمات المالية في سوق أبوظبي العالمي – السجل العام",
  fta: "الهيئة الاتحادية للضرائب – التحقق من الرقم الضريبي والإيرادات",
  gcaa: "الهيئة العامة للطيران المدني – شهادات المشغلين الجويين",
  gleif: "المؤسسة العالمية لمعرف الكيانات القانونية",
  gulfnews: "غلف نيوز",
  "icp-customs": "الهيئة الاتحادية للهوية والجنسية والجمارك وأمن المنافذ وجمارك الإمارات – بطاقات المنشآت والإحصاءات التجارية",
  khaleejtimes: "خليج تايمز",
  "khda-adek": "هيئة المعرفة والتنمية البشرية ودائرة التعليم والمعرفة – المدارس الخاصة ومؤسسات التعليم العالي",
  lseg: "مجموعة بورصة لندن – منصة البيانات وزاوية",
  magnitt: "ماغنت – بيانات رأس المال الجريء والشركات الناشئة",
  marketfeed: "تغذية معلومات السوق",
  mergermarket: "ميرجرماركت – صفقات الاندماج والاستحواذ",
  moei: "وزارة الطاقة والبنية التحتية – المقاولون ومرخصو الطاقة والنقل",
  "moet-agencies": "سجل الوكالات التجارية في وزارة الاقتصاد والسياحة",
  "moet-ec-register": "سجل قرارات التركز الاقتصادي في وزارة الاقتصاد والسياحة",
  "moet-ubo": "سجلات المستفيد الحقيقي والشركاء في وزارة الاقتصاد والسياحة (قرار مجلس الوزراء رقم 109 لسنة 2023)",
  mof: "وزارة المالية – التحقق من الإيرادات",
  "mof-procurement": "منصة المشتريات الرقمية في وزارة المالية – سجل الموردين الاتحادي",
  "mohap-ede": "وزارة الصحة ووقاية المجتمع ومؤسسة الإمارات للدواء – المنشآت الصيدلانية",
  mohre: "سجل المنشآت في وزارة الموارد البشرية والتوطين",
  moiat: "السجل الصناعي في وزارة الصناعة والتكنولوجيا المتقدمة وشهادات القيمة الوطنية المضافة",
  "ner-g2g": "السجل الاقتصادي الوطني – الربط الحكومي",
  news: "أخبار المنافسة",
  "news-rss": "خلاصات غلف نيوز وذا ناشيونال وأرابيان بزنس",
  "northern-deds": "دوائر التنمية الاقتصادية في عجمان ورأس الخيمة والفجيرة وأم القيوين",
  "open-data-master": "السجل الموحد للشركات من البيانات المفتوحة",
  orbis: "أوربس من موديز (بيورو فان دايك) – البيانات المالية والملكية",
  registry: "السجل الاقتصادي الوطني",
  "sharjah-sedd": "دائرة التنمية الاقتصادية في الشارقة – البحث في الرخص",
  "simulated-economy": "بيانات الاقتصاد التجريبية (المحاكيات)",
  spglobal: "إس آند بي كابيتال آي كيو برو",
  "str-amadeus": "إس تي آر وأماديوس – مؤشرات الفنادق والسياحة",
  "tdra-telecom": "سجل المرخصين في هيئة تنظيم الاتصالات والحكومة الرقمية",
  thenational: "ذا ناشيونال",
  ubo: "الاستعلام عن المستفيد الحقيقي (بصلاحية السلطة المختصة)",
  wam: "وكالة أنباء الإمارات (وام)",
  wikidata: "ويكي بيانات – المؤسسات الإماراتية",
  wikipedia: "ويكيبيديا الإنجليزية – قوائم الشركات",
  zawya: "زاوية – أسواق رأس المال في الشرق الأوسط",
};

export function dataSourceText(key: string, name: string, locale: string): string {
  return locale.startsWith("ar") ? SOURCES_AR[key] ?? name : name;
}
